export enum PRResultCodes {
  SUCCESS = 'WCS0000',
  GENERIC_ERROR = 'WCS0001',
  MISSING_PARAMETER = 'WCAS0002',
  INVALID_AUTH_TOKEN = 'WCAS0014',
  INVALID_CODE = 'WCAS0018',
  INVALID_PASSWORD = 'WCAS0005',
}
